import type { ISelfieQuery } from "lib/queries/__generated__/SelfieQuery.generated";

export default function checkCanSkipToBlackCheckout(viewer: Exclude<ISelfieQuery["selfie"], null>) {
  if (viewer.isBlack) {
    return false;
  }

  return (
    viewer.viewerCanPurchaseBlack ||
    ["Black - Inscrições Abertas", "Black - Últimos Dias"].some((tag) => {
      return viewer.activeCampaignContactTags.includes(tag);
    })
  );
}
